import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import router from 'next/router';
import {
  Menu,
  MenuItem,
} from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined';
import { toast } from 'react-toastify';
import { httpsCallable } from '@firebase/functions';
import {
  collection,
  doc,
  getDocs,
  getDoc,
} from 'firebase/firestore';
import { firebaseFireStore } from '../../config/firebaseFirestore';

import DynamicDialog from './DynamicDialog';
import PhoneAuthDialog from './PhoneAuthDialog';
import TransactionsHistory from './transactionHistory';
import FollowingDialog from '../Dialog/FollowingDialog';
import { firebaseBigFireStore } from '../../config/firebaseFireBig';
import { firebaseFunctions } from '../../config/firebaseFunctions';
import { getUserProfileImg } from '../../helpers/regex';
import WalletRecoverySection from './WalletRecoverySection';

export default function ProfileComponent() {
  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const userWalletRedux = useSelector((state) => state.walletReducer);

  const [walletid] = useState('00000000-0000-0000-0000-000000000000');
  const [dialogType, setdialogType] = useState('');
  const [dialogState, setdialogState] = useState(false);
  const [transactionHisDialogState, settransactionHisDialogState] =
    useState(false);
  const [phoneAuthDialogState, setphoneAuthDialogState] = useState(false);
  const [phoneAuthDialogView, setphoneAuthDialogView] = useState(1);
  const [isEmailVerfied, setisEmailVerfied] = useState(true);
  const [followingCount, setfollowingCount] = useState(null);
  const [FollowingDialogState, setFollowingDialogState] = useState(false);
  const [userDataExits, setuserDataExits] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const bsvRate = useSelector((state) => state.bsvRateReducer.bsvRate);
  useEffect(() => {
    if (userDataRedux) {
      setisEmailVerfied(userDataRedux.emailVerified);
      getFollowing();
      getUserPIIData();
      // const q = query(
      //   doc(
      //     firebaseBigFireStore,
      //     `pathStore`,
      //     userDataRedux.uid,
      //     `wallets`,
      //     walletid,
      //   ),
      // );

      // const pathStoreWalletsRef = onSnapshot(
      //   q,
      //   (snapshot) => {
      //     // return   snapshot.forEach((data)=>{
      //     //   console.log(data)
      //     // })
      //     if (snapshot) {
      //       let resWalletsData = snapshot.data();
      //       const utoxBalance =
      //         resWalletsData?.userUtxos?.reduce((total, obj) => {
      //           return obj.value + total;
      //         }, 0) || 0;
      //       const totalBalance = utoxBalance; //* stateRef.current.currency
      //       // console.log('balance retrieved ', totalBalance)
      //       // console.log(resWalletsData)
      //       const bsv = totalBalance / 100000000 || 0;
      //       // var balance = totalBalance * currencyUsd;

      //       dispatch(updateWalletBalance(bsv));
      //     }
      //   },
      //   function (err) {
      //     console.log('firestore err', err);
      //     toast.error(err.message);
      //   },
      // );
      // return pathStoreWalletsRef;
    }
  }, [userDataRedux]);

  const getUserPIIData = async () => {
    const docRef = doc(firebaseBigFireStore, 'PIIDetails', userDataRedux.uid);

    let dbDoc = await getDoc(docRef);

    if (dbDoc.exists) {
      setuserDataExits(true);
    }
  };

  const getFollowing = async () => {
    let dataRef;

    dataRef = await getDocs(
      collection(
        firebaseBigFireStore,
        'musicartSellers',
        userDataRedux.uid,
        'followingArtists',
      ),
    );

    setfollowingCount(dataRef.docs.length);
  };
  const menuDropdown = (
    <>
      <Menu
        anchorEl={anchorEl}
        onMouseLeave={handleClose}
        keepMounted={false}
        getContentAnchorEl={null}
        // container={document.getElementById('dropdown-conttt')}
        // PopoverClasses={{onClick:handleClose,onTouchStart:handleClose}}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        elevation={3}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          className="py-2"
          onClick={() => {
            handleClose();
            router.push(
              `/collector/${
                userDataRedux && userDataRedux.uid ? userDataRedux.uid : ''
              }?tab=Settings`,
            );
          }}
        >
          <div className="flex items-center text-sm text-blueGray-700">
            Manage Collector Profile
          </div>
        </MenuItem>

        <MenuItem
          className="py-2"
          onClick={() => {
            handleClose();
            router.push(`/PII/` + userDataRedux.uid);
          }}
        >
          <div className="flex items-center text-sm text-blueGray-700">
            {userDataExits ? 'Update' : 'Add'} Your PII Details
          </div>
        </MenuItem>

        <MenuItem
          className="py-2"
          onClick={() => {
            handleClose();
            setdialogType('update-username');
            setdialogState(true);
          }}
        >
          <div className="flex items-center text-sm text-blueGray-700">
            Update Username
          </div>
        </MenuItem>
        <MenuItem
          className="py-2"
          onClick={() => {
            handleClose();
            setdialogType('update-email');
            setdialogState(true);
          }}
        >
          <div className="flex items-center text-sm text-blueGray-700">
            Update Email
          </div>
        </MenuItem>

        <MenuItem
          className="py-2"
          onClick={() => {
            handleClose();
            setdialogType('update-password');
            setdialogState(true);
          }}
        >
          <div className="flex items-center text-sm text-blueGray-700">
            Update Password
          </div>
        </MenuItem>
        <MenuItem
          className="py-2"
          onClick={() => {
            handleClose();
            setdialogType('update-image');
            setdialogState(true);
          }}
        >
          <div className="flex items-center text-sm text-blueGray-700">
            {userDataRedux && userDataRedux.photoURL ? 'Update ' : 'Add '}
            Image
          </div>
        </MenuItem>
        <MenuItem
          className="py-2"
          onClick={() => {
            handleClose();
            setphoneAuthDialogState(true);
            setphoneAuthDialogView(1);
          }}
        >
          <div className="flex items-center text-sm text-blueGray-700">
            {userDataRedux && userDataRedux.phoneNumber ? 'Update ' : 'Add '}
            Phone Number
          </div>
        </MenuItem>
        <MenuItem
          className="py-2"
          onClick={() => {
            handleClose();
            setdialogType('update-account');
            setdialogState(true);
          }}
        >
          <div className="flex items-center text-sm text-blueGray-700">
            Delete Account
          </div>
        </MenuItem>
      </Menu>
    </>
  );

  const resendEmailVerficationLink = async () => {
    toast.info('Verification email sent', {
      position: 'bottom-left',
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      zIndex: 2147483641,
    });
    try {
      const resendEmailAPI = httpsCallable(
        firebaseFunctions,
        'verificationEmailLink',
      );
      const res = await resendEmailAPI();
    } catch (err) {
      console.log('err', err);
    }
  };

  return (
    <>
      <main className="profile-page">
        <section className="relative block h-500-px">
          <div className="profile__banner absolute top-0 w-full h-full bg-center bg-cover"></div>
          <div
            className="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-16"
            style={{ transform: 'translateZ(0)' }}
          >
            <svg
              className="absolute bottom-0 overflow-hidden"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="text-blueGray-200 fill-current"
                points="2560 0 2560 100 0 100"
              ></polygon>
            </svg>
          </div>
        </section>
        <section className="relative py-16 bg-blueGray-200">
          <div className="container mx-auto px-4">
            <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg -mt-64">
              <div className="px-6">
                <div className="flex flex-wrap justify-center">
                  <div className=" w-full  align-center flex justify-center">
                    <div className="absolute">
                      <img
                        alt="profile-image"
                        src={getUserProfileImg(userDataRedux)}
                        style={{
                          transform: 'translate(0px, -65%)',
                        }}
                        className="shadow-xl   rounded-full h-auto align-middle border-none   top-8    max-w-150-px max-h-150-px"
                      />
                    </div>
                  </div>
                  <div className="w-auto lg:w-4/12 flex justify-end self-center lg:justify-end md:justify-end lg:order-3 lg:text-right lg:self-center">
                    <div className=" py-6 md:px-3 mt-32 sm:mt-0">
                      <button
                        className="ant-dropdown-trigger  bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none mb-1 ease-linear transition-all duration-150"
                        type="button"
                        id="dropdown-basic"
                        onClick={handleClick}
                        // onTouchStart={handleClick}
                        // onMouseLeave={handleClose}
                      >
                        Edit profile
                      </button>
                      {menuDropdown}
                    </div>
                  </div>
                  <div className="w-full lg:w-4/12 px-4 lg:order-1">
                    <div className="row lg:justify-start justify-center py-4 lg:pt-4 pt-8">
                      <div
                        className="lg:mr-0 mr-0 p-3 text-center sm:w-6/12 cursor-pointer"
                        onClick={() => {
                          setFollowingDialogState(true);
                        }}
                      >
                        <span
                          style={{ minHeight: '28px' }}
                          className="text-xl font-bold block uppercase tracking-wide text-blueGray-600"
                        >
                          {followingCount !== null && followingCount}
                        </span>
                        <span className="text-sm text-blueGray-400">
                          Following
                        </span>
                      </div>
                      {/* <div className="mr-4 p-3 text-center w-full sm:w-3/12">
                        <span className="text-xl font-bold block uppercase tracking-wide text-blueGray-600">
                          {likesCount}
                        </span>
                        <span className="text-sm text-blueGray-400">Likes</span>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="text-center mt-4">
                  <h3 className="head__text text-4xl font-semibold leading-normal text-blueGray-700 mb-0 pb-0">
                    {userDataRedux ? `@${userDataRedux.displayName}` : ''}
                  </h3>
                  <div
                    style={{
                      position: 'relative',
                      top: -2,
                    }}
                    className="text-base leading-normal mt-0 mb-2 text-blueGray-400 font-normal"
                  >
                    {userDataRedux && userDataRedux.email && (
                      <div>
                        <MailOutlineIcon
                          style={{ fontSize: 18 }}
                          className="text-blueGray-500 mr-2"
                        />
                        {userDataRedux && userDataRedux.email
                          ? userDataRedux.email
                          : '-'}
                      </div>
                    )}

                    {userDataRedux && userDataRedux.phoneNumber && (
                      <div>
                        <PhoneOutlinedIcon
                          style={{ fontSize: 18 }}
                          className="text-blueGray-500 mr-2"
                        />
                        {userDataRedux.phoneNumber}
                      </div>
                    )}
                  </div>
                </div>
                {!isEmailVerfied && (
                  <div
                    style={{
                      margin: '20px auto',
                      position: 'relative',
                      cursor: 'pointer',
                    }}
                    className="alert-old-tran"
                    onClick={resendEmailVerficationLink}
                  >
                    <Alert severity="info">
                      <AlertTitle>Your email has not been verified!</AlertTitle>
                      Please verify your email, after clicking this alert you
                      will receive an verification email —{' '}
                      <strong>verify now.</strong>
                    </Alert>
                  </div>
                )}

                {/* Wallet Recovery Section */}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginBottom: 60,
                    maxWidth: 600,
                    margin: '0 auto 60px',
                    padding: '0 20px',
                  }}
                >
                  <WalletRecoverySection />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <DynamicDialog
        userEmail={userDataRedux ? userDataRedux.email : ''}
        dialogState={dialogState}
        setdialogState={setdialogState}
        dialogType={dialogType}
        photoUrl={getUserProfileImg(userDataRedux)}
        walletid={walletid}
        walletmnemonic={
          userWalletRedux && userWalletRedux.mnemonic
            ? userWalletRedux.mnemonic
            : ''
        }
        uid={userDataRedux && userDataRedux.uid ? userDataRedux.uid : ''}
        userWalletRedux={userWalletRedux}
      />
      <PhoneAuthDialog
        dialogState={phoneAuthDialogState}
        setdialogState={setphoneAuthDialogState}
        uid={userDataRedux && userDataRedux.uid ? userDataRedux.uid : ''}
        phoneAuthDialogView={phoneAuthDialogView}
        setphoneAuthDialogView={setphoneAuthDialogView}
        updateNumber={userDataRedux && userDataRedux.phoneNumber ? true : false}
        userDataRedux={userDataRedux}
      />

      {/* <TransactionsHistoryDialog */}
      {/* dialogState={transactionHisDialogState} */}
      {/* setdialogState={settransactionHisDialogState} */}
      {/* userId={userDataRedux && userDataRedux.uid ? userDataRedux.uid : null} */}
      {/* /> */}

      <TransactionsHistory
        dialogState={transactionHisDialogState}
        setdialogState={settransactionHisDialogState}
        userId={userDataRedux && userDataRedux.uid ? userDataRedux.uid : null}
        // wallethistory={
        //   userWalletRedux && userWalletRedux.wallethistory
        //     ? userWalletRedux.wallethistory
        //     : []
        // }
        balance={userWalletRedux.balance}
      />

      <FollowingDialog
        dialogState={FollowingDialogState}
        setdialogState={setFollowingDialogState}
        artistId={userDataRedux && userDataRedux.uid ? userDataRedux.uid : null}
      />
    </>
  );
}
